import { SITE_API_ENABLED } from "../../api/config"
import { useSiteStatus } from "../../api/queries"

export type OnSiteState = ReturnType<typeof useOnSite>

/**
 * Состояние «группа на сайте» — единственное, ради чего интерфейс лезет в базу
 * самого сайта.
 *
 * Спрашиваем рижский узел (`/ai/site/group-status`), и это меняет всё поведение
 * хука. Раньше запрос шёл в `ecm`, недоступная база сайта роняла там процесс
 * целиком, и вокруг этого был выстроен целый обряд: проверка только по кнопке,
 * память в `sessionStorage` о том, отвечала ли база в этой вкладке, запрет
 * запроса у пустых групп. Рижский узел до базы достаёт, от её недоступности не
 * падает и отвечает за доли секунды — обряд удалён, запрос ходит сам.
 *
 * Осталась одна оговорка: у группы без товаров спрашивать нечего, и мы этого
 * не делаем — не ради безопасности, а чтобы не гонять запрос впустую.
 */
export function useOnSite(
	productGroupId: string | null,
	websiteId: number | null,
	productCount?: number
) {
	const empty = productCount === 0
	const query = useSiteStatus(productGroupId, websiteId, !empty)

	return {
		/** `undefined` — ответа ещё нет. Значение живёт в кэше запроса, поэтому
		 *  проверка, запущенная в панели, видна и в шапке карточки. */
		isOnSite: query.data?.onSite,
		/** Почему группа не поедет на сайт — по мнению рижского узла. */
		blockers: query.data?.blockers ?? [],
		/** Сколько строк группы лежит сейчас в таблицах сайта. */
		rows: query.data?.rows ?? null,
		checking: query.isFetching,
		error: query.isError ? query.error : null,
		/** Спрашивать нечего: в группе нет товаров. */
		empty,
		/** Рижского BFF отсюда не видно — см. `SITE_API_ENABLED`. */
		blocked: !SITE_API_ENABLED,
		check: () => {
			if (empty || !SITE_API_ENABLED) return
			void query.refetch()
		},
	}
}
